import React from 'react'
import { Switch, Route } from 'react-router-dom'

import {
    withRouter
} from 'react-router-dom'

//Plugins
import styled from 'styled-components';
import Home from './Pages/Home';
import More from '../components/MoreWork';
import SingleProject from './Pages/SingleProject';
import SingleBlog from './Pages/SingleBlog';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import BlogPage from './Pages/BlogPage';
import  Navbar  from '../components/Navbar';
import GA from '../utils/googleanalytics'

const Container = styled.div`
  min-height:100%;
`

function PublicView(props) {
    return (
      <Container>
          <Navbar/>
          <ScrollToTop/>
          { GA.init() && <GA.RouteTracker /> }
          <Switch>
            <Route exact path='/' component={BlogPage}/>
            <Route exact path='/project/:id' component={SingleProject}/>
            <Route exact path='/blogs' component={BlogPage}/>
            {/* <Route exact path="/blogs/:id" component={SingleBlog}/> */}
            <Route exact path='/morework' component={More}/>
            {/* <Route exact path='/hidden-index' component={Home}/> */}
          </Switch>
          <Footer/>
      </Container>
    )
  }
  export default withRouter(PublicView);
  
  